import axios from "axios";
import keycloak from "./keycloak";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${keycloak.token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Не повторяем запросы, которые сами являются retry после refresh
    if (originalRequest._retry) {
      // Токен не обновился — логаут
      localStorage.clear();
      window.location.href =
        process.env.REACT_APP_PORTAL || window.location.origin;
      return Promise.reject(error);
    }

    if (error.response?.status === 401) {
      originalRequest._retry = true;

      try {
        const refreshed = await keycloak.updateToken(70);
        if (refreshed) {
          console.log("Токен обновлен")
        }
        // повторяем оригинальный запрос с новым токеном
        originalRequest.headers.Authorization = `Bearer ${keycloak.token}`;
        return api(originalRequest);
      } catch (refreshErr) {
        // Рефреш не удался — чистим и логаут
        localStorage.clear();
        window.location.href =
          process.env.REACT_APP_PORTAL || window.location.origin;
        return Promise.reject(refreshErr);
      }
    }

    return Promise.reject(error);
  },
);

export default api;
